import React, { FC } from 'react'

import DefaultLayout from '../../layouts/DefaultLayout'
import { ActionButtonProps } from '../../components/ActionButton'
import { Image } from '../../types'

import * as SC from './styled'

export type MaintenanceTemplateProps = {
  logo: Image
  background: string
  title: string
  text: string
  cta: ActionButtonProps
}

const MaintenanceTemplate: FC<MaintenanceTemplateProps> = ({
  logo,
  background,
  title,
  text,
  cta,
}) => {
  return (
    <DefaultLayout>
      <SC.Background $background={background}>
        <SC.CardWrapper header={{ title }}>
          <SC.Logo src={logo.src} alt={logo.alt} />
          <SC.Text>{text}</SC.Text>
          <SC.Button {...cta} />
        </SC.CardWrapper>
      </SC.Background>
    </DefaultLayout>
  )
}

export default MaintenanceTemplate
